<template>
  <div>
    <div class="btn-bottom-fix-payment">
      <button class="btn--home btn--shadow btn--md btn--violet btn-anim" @mouseup="alertHomeYn = true">
        <i class="ico-home"></i><span>{{ $t('User.Order.msg9') }}</span>
      </button>
      <button class="btn--line btn--md btn-anim" @mouseup="staffCallYn = true">
        <i class="ico-staff ico-sm"></i><span>{{ $t('User.Order.msg10') }}</span>
      </button>
      <button class="btn--line btn--md btn-anim" @mouseup="helperYn = true">
        <i class="ico-helper ico-sm"></i><span>{{ $t('User.Order.msg11') }}</span>
      </button>
    </div>
    <Helper
      @setDarkYn="
        $store.commit('setDarkModeYn');
        helperYn = false;
      "
      @setHelper="
        helperYn = false;
        staffCallFinishYn = true;
      "
      @setHelperHeight="
        $store.commit('setHelperHeightYn');
        helperYn = false;
      "
      @closeHelper="helperYn = false"
      :helperYn="helperYn"
    />
    <StaffCall
      @closeStaffCall="staffCallYn = false"
      @setStaffCall="
        staffCallYn = false;
        staffCallFinishYn = true;
      "
      :staffCallYn="staffCallYn"
    />
    <StaffCallFinish @closeStaffCallFinish="staffCallFinishYn = false" :staffCallFinishYn="staffCallFinishYn" />

    <AlertHome :alertHomeYn="alertHomeYn" @closeAlert="alertHomeYn = false" @setHome="$router.push('/user/idle')" />
  </div>
</template>

<script>
import helper from '@/components/modal/Helper.vue';
import staffCall from '@/components/modal/StaffCall.vue';
import staffCallFinish from '@/components/modal/StaffCallFinish.vue';
import alertHome from '@/components/modal/alert/AlertHome.vue';

export default {
  name: 'btnBottom',
  props: {},
  methods: {},
  data() {
    return {
      helperYn: false,
      staffCallYn: false,
      staffCallFinishYn: false,
      alertHomeYn: false,
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {
    this.$showButtonAnimation();
  },
  components: {
    Helper: helper,
    StaffCall: staffCall,
    StaffCallFinish: staffCallFinish,
    AlertHome: alertHome,
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode(value) {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style scoped></style>
